import './LoginPage.css';

import MuiAppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import Modal from "@mui/material/Modal";
import { alpha, styled } from "@mui/material/styles";
import axios from "axios";
import React, { useEffect, useState } from "react";
import "react-phone-input-2/lib/style.css";
import "../App.css";
import { useModal } from "../context/context";
import { Link, useNavigate } from "react-router-dom";
import { API_BASE_URL } from '../utils';


function validateEmail(email) {
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

    return emailPattern.test(email);
}

export default function LoginPage({ clbk }) {

    const navigate = useNavigate();

    const [anchorEl, setAnchorEl] = React.useState(null);
    const openMyAccount = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleCloseMyAccount = () => {
        setAnchorEl(null);
    };
    const initialTimeInSeconds = 60;
    const [timeInSeconds, setTimeInSeconds] = useState(initialTimeInSeconds);
    const [showResend, setShowResend] = useState(false);
    const { toggle } = useModal();
    const [mobile, setMobile] = useState("");
    const [response, setResponse] = useState(null);
    const [otp, setOtp] = useState("");
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [gender, setGender] = useState("");
    const [updateemail, setUpdateEmail] = useState("");

    const handleGenderChange = (event) => {
        setGender(event.target.value);
    };
    const handleDobChange = (newDate) => {
        setDob(newDate);
    };
    const handleEmailChangevalue = (e) => {
        setEmail(e.target.value);
    };
    const handleEmailChangevalue1 = (e) => {
        setUpdateEmail(e.target.value);
    };
    const getEighteenYearsAgoDate = () => {
        const date = new Date();
        date.setFullYear(date.getFullYear() - 18);
        return date.toISOString().split("T")[0];
    };
    const [dob, setDob] = useState("");
    const handleDateChange = (event) => {
        setDob(event.target.value);
    };
    var url = `${API_BASE_URL}/master/assets/uploads/`;
    useEffect(() => {
        if (toggle) {
            setOpenLogin(true);
        }
    }, [toggle]);
    useEffect(() => {

        const updateTimer = () => {
            if (timeInSeconds > 0) {
                setTimeInSeconds((prevTime) => prevTime - 1);
            } else {
                setShowResend(true);
            }
        };

        const intervalId = setInterval(updateTimer, 1000);


        return () => clearInterval(intervalId);
    }, [timeInSeconds]);
    const handleResendOTP = () => {
        setTimeInSeconds(initialTimeInSeconds);
        setShowResend(false);
    };
    const formattedTime = `${Math.floor(timeInSeconds / 60)}:${(
        timeInSeconds % 60
    )
        .toString()
        .padStart(2, "0")}`;
    const handleSubmit = async (e) => {
        e.preventDefault();
        handleResendOTP();
        try {
            const formData = new FormData();
            formData.append("mobile", mobile);
            formData.append("otpType", "text");

            const response = await axios.post(
                `${API_BASE_URL}/master/Api/UserAuth/Login`,
                formData
            );

            setResponse(response.data);
            handleOpenOtp();
        } catch (error) {
            console.error("Error:", error);
        }
    };

    const handleSubmitotp = async (e) => {
        try {
            const formData = new FormData();
            formData.append("mobile", mobile);
            formData.append("otp", otp);

            const response = await axios.post(
                `${API_BASE_URL}/master/Api/UserAuth/verifyOtp`,
                formData
            );

            if (response.data.status === true) {
                const userData = JSON.stringify(response.data.data);
                localStorage.setItem("userData", userData);
                if (response.data.type === "old") {
                    if (clbk) {
                        clbk(JSON.parse(userData));
                    } else {
                        navigate("/");
                    }
                } else {
                    handleOpenSignup();
                }
            } else {
                alert("Invalid OTP. Please try again.");
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };

    const handleSubmitSignup = async (e) => {
        try {
            const formData = new FormData();
            formData.append("mobile", mobile);
            formData.append("whatsapp", mobile);
            formData.append("name", name);
            formData.append("email", email);
            formData.append("dob", dob);
            formData.append("gender", gender);
            if (!validateEmail(email)) {
                alert("Please enter a valid email address.");
                return;
            }
            const response = await axios.post(
                `${API_BASE_URL}/master/Api/UserAuth/updateDetails`,
                formData
            );

            setResponse(response.data);

            if (response.data.status === true) {
                const userData = JSON.stringify(response.data.data[0])
                localStorage.setItem("userData", userData);
                if (clbk) {
                    clbk(JSON.parse(userData));
                } else {
                    window.location.reload();
                }

            } else {

            }
        } catch (error) {
            console.error("Error:", error);
        }
    };
    const [openLogin, setOpenLogin] = React.useState(false);
    const handleOpenLogin = () => {
        setOpenLogin(true);
    };
    const handleCloseLogin = (e) => {
        e.preventDefault()
        setOpenLogin(false);
        // window.location.reload();
    };
    const [openOtp, setOpenOtp] = React.useState(false);
    const handleOpenOtp = () => {
        setOpenOtp(true);
    };
    const handleCloseOtp = () => {
        setOpenOtp(false);
    };
    const [openSignup, setOpenSignup] = React.useState(false);
    const handleOpenSignup = () => {
        setOpenSignup(true);
    };
    const handleCloseSignup = () => {
        setOpenSignup(false);
    };
    const loginerror = () => { };
    const otperror = () => { };
    const [value, setValue] = useState("");
    const userdata = JSON.parse(localStorage.getItem("userData"));
    var url = `${API_BASE_URL}/master/assets/uploads/`;
    useEffect(() => {
        setOpenLogin(true);
    }, []);

    return (
        <div className='login-page-section'>
        <div className='login-warpper'>
            {openLogin && (
                <div className="">
                    <Box className="responsive-modal--log--in">
                        <div className="login-content">
                            <div className="Plan--your--event--popup--1--img">
                            </div>
                            <div className="login-content1 mt-2">
                                <h4>Login/Signup</h4>
                                <div className="login-phoneno">
                                    <lable className="lable">WhatsApp Number</lable>
                                    <input
                                        className="phone-input"
                                        placeholder="Enter"
                                        type="number"
                                        value={mobile}
                                        maxLength="10"
                                        onChange={(e) => {
                                            const numericValue = e.target.value.replace(/\D/g, "");

                                            if (numericValue.length <= 10) {
                                                setMobile(numericValue);
                                            }
                                        }}
                                        pattern="[0-9]*"
                                        title="Please enter only numbers"
                                    />

                                </div>
                                <div className="login-submit-button">
                                    <button
                                        onClick={mobile.length == 10 ? handleSubmit : loginerror}
                                        className={
                                            mobile.length === 10 ? "pink-button" : "gray-button"
                                        }
                                    >
                                        Log in
                                    </button>
                                </div>
                                <p className="mt-2 w-85 privacy-policy-aggreement ">
                                    By proceeding, you agree to Party Witty's
                                    <Link to="/privacy-policy">
                                        {" "}
                                        &nbsp;Privacy Policy&nbsp;
                                    </Link>{" "}
                                    <br />
                                    and{" "}
                                    <Link to="/term-conditions-policy" data-toggle="modal" data-target="#exampleModal">
                                        &nbsp;Terms & Condition&nbsp;
                                    </Link>
                                    &nbsp;
                                </p>
                                <Modal
                                    open={openOtp}
                                    onClose={handleCloseOtp}
                                    aria-labelledby="child-modal-title"
                                    aria-describedby="child-modal-description"
                                >
                                    <Box className="responsive-modal--log--in">
                                        <div className="login-content">
                                            <div className="Plan--your--event--popup--1--img">
                                            </div>
                                            <div className="login-content1">
                                                <h4 className="m-0">Confirm your number </h4>
                                                <p className="mb-2 ">
                                                    {mobile}{" "}
                                                    <span
                                                        className="login-content11-otp"
                                                        onClick={handleCloseOtp}
                                                    >
                                                        Edit
                                                    </span>
                                                </p>
                                                <div className="login-content11">
                                                    <p>Enter the 6 digit OTP we've sent by WhatsApp</p>
                                                </div>
                                                <div className="login-otp-content">
                                                    <div className="login-otp-text">
                                                        <input
                                                            type="text"
                                                            value={otp}
                                                            maxlength="6"
                                                            onChange={(e) => {
                                                                const numericValue = e.target.value.replace(
                                                                    /\D/g,
                                                                    ""
                                                                );

                                                                setOtp(numericValue);
                                                            }}
                                                            pattern="[0-9]*"
                                                            title="Please enter only numbers"
                                                            size="small"
                                                        />
                                                    </div>

                                                    <button
                                                        onClick={
                                                            otp.length == 6 ? handleSubmitotp : otperror
                                                        }
                                                        className={
                                                            otp.length === 6 ? "pink-button" : "gray-button"
                                                        }
                                                        disabled={otp.length === 0}
                                                    >
                                                        Verify OTP
                                                    </button>
                                                    <div id="timer" className="login-otp-content-timer">
                                                        {showResend ? (
                                                            <p
                                                                className="resend--otp--after--time"
                                                                onClick={handleSubmit}
                                                            >
                                                                Resend OTP
                                                            </p>
                                                        ) : (
                                                            `Resend OTP in ${formattedTime}`
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="login-otp-close-button">
                                            <Button onClick={handleCloseOtp}>
                                                <p>X</p>
                                            </Button>
                                        </div>
                                    </Box>
                                </Modal>
                            </div>
                        </div>
                    </Box>

                    <Modal
                        open={openSignup}
                        onClose={handleCloseSignup}
                        aria-labelledby="child-modal-title"
                        aria-describedby="child-modal-description"
                    >
                        <Box className="responsive-modal111">
                            <div className="login-content">
                                <div className="Plan--your--event--popup--1--img"></div>
                                <div className="login-content1">
                                    <h3 className="mt-2">Sign Up</h3>
                                    <h4>Enter your information to register</h4>
                                    <div className="login-content1--text-field ">
                                        <Box
                                            sx={{
                                                alignItems: "center",
                                                "& > :not(style)": { m: 1 },
                                            }}
                                        >
                                            <lable className="lable">Name*</lable>
                                            <input
                                                className="input-field signupinput--field mt-0"
                                                required
                                                placeholder="Enter Your Name"
                                                helperText=""
                                                id="demo-helper-text-aligned"
                                                type="text"
                                                label="Name"
                                                value={name}
                                                onChange={(e) => setName(e.target.value)}
                                                size="small"
                                            />

                                            <div className="gender-group">
                                                <fieldset>
                                                    <legend className="gender-heading m-0 gender--lable">
                                                        Gender
                                                    </legend>
                                                    <label className=" gender--lable11">
                                                        <input
                                                            type="radio"
                                                            name="gender"
                                                            value="male"
                                                            onChange={handleGenderChange}

                                                        />{" "}
                                                        Male
                                                    </label>
                                                    <label className="margin-left gender--lable11">
                                                        <input
                                                            type="radio"
                                                            name="gender"
                                                            value="female"
                                                            onChange={handleGenderChange}
                                                        />{" "}
                                                        Female
                                                    </label>
                                                </fieldset>
                                            </div>
                                            <div className="gender-group--1">
                                                <label className="lable">
                                                    Email*
                                                    <input
                                                        placeholder="Enter Your Email"
                                                        className="input-field signupinput--field1"
                                                        helperText=""
                                                        type="email"
                                                        required
                                                        id="demo-helper-text-aligned"
                                                        label="Email"
                                                        value={email}
                                                        onChange={handleEmailChangevalue}
                                                        size="small"
                                                    />
                                                </label>

                                                <label className="lable">
                                                    DOB*
                                                    <input
                                                        type="date"
                                                        className="input-field signupinput--field1"
                                                        placeholder="date"
                                                        label="DOB"

                                                        max={getEighteenYearsAgoDate()}
                                                        value={dob}
                                                        onChange={handleDateChange}

                                                    />
                                                </label>
                                            </div>
                                            <div className="signup--submit--button ">
                                                <button
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        handleSubmitSignup();
                                                    }}
                                                    className={
                                                        name && gender && email && dob
                                                            ? "pink-button"
                                                            : "gray-button"
                                                    }
                                                >
                                                    Submit
                                                </button>
                                            </div>
                                            <p className="mt-1 w-85 privacy-policy-aggreement1">
                                                By proceeding, you agree to Party Witty's <br />
                                                <a href="./privacy-policy">
                                                    {" "}
                                                    &nbsp;Privacy Policy&nbsp;
                                                </a>{" "}
                                                and <a href="#">&nbsp;Terms & Condition&nbsp;</a> &nbsp;
                                            </p>
                                        </Box>
                                    </div>
                                </div>
                            </div>
                            <div className="close--signup-button">
                                <Button onClick={handleCloseSignup}>
                                    <p>X</p>
                                </Button>
                            </div>
                        </Box>
                    </Modal>
                </div>
            )}
            <div
                class="modal fade"
                id="exampleModal"
                tabindex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            >
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">
                                Modal title
                            </h5>
                            <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">...</div>
                        <div class="modal-footer">
                            <button
                                type="button"
                                class="btn btn-secondary"
                                data-dismiss="modal"
                            >
                                Close
                            </button>
                            <button type="button" class="btn btn-primary">
                                Save changes
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
    );
}
